

import { api_onlineOrder } from '@/utils/request'

// 获取产品列表
export const getBaseProductList = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/product',
    method: 'get',
    params
  })
};
// 获取产品详情
export const getBaseProductDetail = (product_id) => {
  return api_onlineOrder.request({
    url: 'online/admin/product/' + product_id,
    method: 'get',
  })
};
//添加产品
export const createProduct = (data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods',
    method: 'post',
    data
  })
};
//产品 详情
export const getGoodsDetail = (goods_id) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/'+goods_id,
    method: 'get'
  })
};
//产品修改
export const editGoods = (goods_id,data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/'+goods_id,
    method: 'PATCH',
    data
  })
};
// 获取分类列表
export const getGoodsCategory = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/goodsCategory',
    method: 'get',
    params
  })
};
// 新增分类
export const createGoodsCategory = (data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goodsCategory',
    method: 'POST',
    data
  })
};
// 删除分类
export const delGoodsCategory = (id, data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goodsCategory/' + id,
    method: 'DELETE',
    data
  })
};
// 修改分类
export const updateGoodsCategory = (id, data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goodsCategory/' + id,
    method: 'PATCH',
    data
  })
};
/**
 * 商品
 */
// 获取商品列表
export const getProductList = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods',
    method: 'get',
    params
  })
};
// 获取商品sku
export const getProductSkuList = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/sku/list',
    method: 'get',
    params
  })
};


// 下架商品
export const offSale = (goods_id, data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/offSale/' + goods_id,
    method: 'post',
    data
  })
};
// 批量下架商品
export const batchOffSale = (data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/batch/offSale',
    method: 'post',
    data
  })
};
// 上架商品
export const onSale = (goods_id, data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/onSale/' + goods_id,
    method: 'post',
    data
  })
};
// 批量上架商品
export const batchOnSale = (data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/batch/onSale',
    method: 'post',
    data
  })
};

// 删除商品
export const goodsDel = (goods_id, data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/' + goods_id,
    method: 'DELETE',
    data
  })
};
// 批量删除商品
export const batchDels = (data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/batchDelete',
    method: 'post',
    data
  })
};

// 批量分组
export const batchCategory = (category_id, data) => {
  return api_onlineOrder.request({
    url: 'online/admin/goods/category/' + category_id,
    method: 'post',
    data
  })
};

//  订货价格模板
export const priceTem = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem',
    method: 'get',
    params
  })
};
//  添加订货价格模板
export const createPriceTem = (data) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem',
    method: 'POST',
    data
  })
};
//  修改订货价格模板
export const editPriceTem = (id,data) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem/'+id,
    method: 'PATCH',
    data
  })
};
//  删除订货价格模板
export const delPriceTem = (id,data) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem/'+id,
    method: 'DELETE',
    data
  })
};
//  订货价格模板详情
export const detailPriceTem = (id) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem/'+id,
    method: 'get'
  })
};
//  订货价格模板 商品详情
export const detailGoodsPriceTem = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem/goods/'+params.id,
    method: 'get',
    params
  })
};
//  订货价格模板 商品ALL详情
export const detailAllGoodsPriceTem = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem/goodsAll/'+params.id,
    method: 'get',
    params
  })
};
//  订货价格模板 商品修改积分
export const editGoodsPriceTemPoint = (id,data) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem/goodsPointPrice/'+id,
    method: 'POST',
    data
  })
};
//  订货价格模板 商品添加
export const addGoodsPriceTemPoint = (tem_id,data) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem/addGoods/'+tem_id,
    method: 'POST',
    data
  })
};

//  订货价格模板 商品删除
export const delGoodsPriceTemDel = (id) => {
  return api_onlineOrder.request({
    url: 'online/admin/priceTem/goodsPointPrice/'+id,
    method: 'DELETE'
  })
};
// 删除订货模板
// export const priceTem=(params)=>{
//   return api_onlineOrder.request({
//     url: 'online/admin/priceTem',
//     method: 'get',
//     params
//   })
// };

// 整体订货模板-经销商
export const channelLevelDiscountRateDealer = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/channelLevelDiscountRate/dealer',
    method: 'get',
    params
  })
};
// 整体订货模板-经销商-修改
export const editChannelLevelDiscountRateDealer = (level_id,data) => {
  return api_onlineOrder.request({
    url: 'online/admin/channelLevelDiscountRate/dealer/'+level_id,
    method: 'post',
    data
  })
};
// 整体订货模板-门店
export const channelLevelDiscountRateStore = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/channelLevelDiscountRate/store',
    method: 'get',
    params
  })
};
// 整体订货模板-门店-修改
export const editChannelLevelDiscountRateStore = (level_id,data) => {
  return api_onlineOrder.request({
    url: 'online/admin/channelLevelDiscountRate/store/'+level_id,
    method: 'post',
    data
  })
};



// 门店配置
export const channelDiscountRateStore = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/channelDiscountRate/store',
    method: 'get',
    params
  })
};
// 门店配置-设置
export const channelDiscountRateStoreSet = (id,data) => {
  return api_onlineOrder.request({
    url: 'online/admin/channelDiscountRate/store/'+id,
    method: 'POST',
    data
  })
};


// 经销商配置
export const channelDiscountRateDealer = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/channelDiscountRate/dealer',
    method: 'get',
    params
  })
};

// 经销商配置-设置
export const channelDiscountRateDealerSet = (id,data) => {
  return api_onlineOrder.request({
    url: 'online/admin/channelDiscountRate/dealer/'+id,
    method: 'post',
    data
  })
};


// 统计
export const statisticsIndex = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/index',
    method: 'get',
    params
  })
};

// 用户统计
export const statisticsUer = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/statistics/user',
    method: 'get',
    params
  })
};
// 用户统计-折线图数据
export const statisticsUerChart = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/statistics/user/chart',
    method: 'get',
    params
  })
};


// 门店统计
export const statisticsStore = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/statistics/store',
    method: 'get',
    params
  })
};

// 门店统计-明细
export const statisticsStoreLog = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/statistics/store/order',
    method: 'get',
    params
  })
};

// 门店|经销商 订货商品明细
export const statisticsGoodsLog = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/statistics/order/goods/'+params.buyer_id,
    method: 'get',
    params
  })
};


// 经销商统计
export const statisticsDealer = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/statistics/dealer',
    method: 'get',
    params
  })
};

// 经销商统计-明细
export const statisticsDealerLog = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/statistics/dealer/order',
    method: 'get',
    params
  })
};


// 商品统计
export const statisticsGoods = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/statistics/order/goodsStat',
    method: 'get',
    params
  })
};
// 商品统计-折线图数据
export const statisticsGoodsChart = (params) => {
  return api_onlineOrder.request({
    url: 'online/admin/statistics/order/goodsStatChart',
    method: 'get',
    params
  })
};



